import { render, staticRenderFns } from "./LessonContainer.vue?vue&type=template&id=388dba4a&"
import script from "./LessonContainer.vue?vue&type=script&lang=ts&"
export * from "./LessonContainer.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports